import proj4 from 'proj4';

// Interpret NAM easting/northing as Danish ETRS89 / UTM zone 32N (EPSG:25832).
const ADDRESS_PROJECTION = '+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs';

export function addressCoordinatesToLngLat({ xCoordinate, yCoordinate }) {
    if (xCoordinate == null || yCoordinate == null) {
        return null;
    }
    if (!Number.isFinite(xCoordinate) || !Number.isFinite(yCoordinate)) {
        throw new Error('Invalid address coordinates');
    }
    const position = proj4(ADDRESS_PROJECTION, 'EPSG:4326', [xCoordinate, yCoordinate]);
    if (!position.every(Number.isFinite) || Math.abs(position[0]) > 180 || Math.abs(position[1]) > 90) {
        throw new Error('Invalid address coordinates');
    }
    return position;
}
